import {
  patientIntegrationsApi,
  patientRegistrationApi,
} from '@valerahealth/rtk-query'
import { useTranslation } from '@valerahealth/ui-translation'
import { useDispatch } from 'react-redux'
import { MenuItem, ListItemIcon, ListItemText } from '../../base'
import { Upload } from '../../icons'
import { useNotify } from '../Notifications'

interface RegisterToEmrProps {
  treatmentId: string
}

const { useSyncToEmrMutation } = patientIntegrationsApi

export function RegisterToEmr({ treatmentId }: RegisterToEmrProps) {
  const [t] = useTranslation()
  const notify = useNotify()
  const dispatch = useDispatch()
  const [registerToEMR, registerToEMRStatus] = useSyncToEmrMutation()
  return (
    <MenuItem
      disabled={registerToEMRStatus.isLoading}
      onClick={async () => {
        const res = await registerToEMR({ input: { treatmentId } })

        if ('data' in res) {
          notify({
            severity: 'success',
            message: t('PatientSearch.registerToEMRSuccess'),
          })
          dispatch(
            patientRegistrationApi.util.invalidateTags([
              { type: 'patient', id: treatmentId },
            ]),
          )
        } else if ('error' in res) {
          notify({
            severity: 'error',
            message:
              res.error.message === 'dr_chrono_doctor_id_not_found'
                ? "The patient's care team member could not be found in the EMR"
                : res.error.message || t('PatientSearch.registerToEMRError'),
          })
        } else {
          notify({
            severity: 'error',
            message: t('PatientSearch.registerToEMRError'),
          })
        }
      }}
    >
      <ListItemIcon>
        <Upload />
      </ListItemIcon>
      <ListItemText>Push to EMR</ListItemText>
    </MenuItem>
  )
}
